export default `.ids-tab-divider {
  background-color: var(--ids-tab-divider-color-background);
  display: block;
  height: calc(100% - 16px);
  position: relative;
  margin-inline-start: 20px;
  margin-inline-end: 12px;
  top: var(--ids-space-xs);
  width: 1px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2J1aWxkcy9pbmZvci1kZXNpZ24vZW50ZXJwcmlzZS13Yy9zcmMvY29tcG9uZW50cy9pZHMtdGFicyIsInNvdXJjZXMiOlsiaWRzLXRhYi1kaXZpZGVyLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQ0E7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBIiwic291cmNlc0NvbnRlbnQiOlsiXG4uaWRzLXRhYi1kaXZpZGVyIHtcbiAgYmFja2dyb3VuZC1jb2xvcjogdmFyKC0taWRzLXRhYi1kaXZpZGVyLWNvbG9yLWJhY2tncm91bmQpO1xuICBkaXNwbGF5OiBibG9jaztcbiAgaGVpZ2h0OiBjYWxjKDEwMCUgLSAxNnB4KTtcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xuICBtYXJnaW4taW5saW5lLXN0YXJ0OiAyMHB4O1xuICBtYXJnaW4taW5saW5lLWVuZDogMTJweDtcbiAgdG9wOiB2YXIoLS1pZHMtc3BhY2UteHMpO1xuICB3aWR0aDogMXB4O1xufVxuIl19 */`;
